import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { BcgNinFlowService } from 'src/app/modules/self-registration/business-competition-registration/bcg-nin-flow.service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard {
  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router,
    private readonly _ninFlowService: BcgNinFlowService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this._authService.isLoggedIn()) {
      return true;
    }

    if (this.allowDuplicateAccountFlow(route)) {
      return true;
    }

    this._authService.checkRole();
    return false;
  }

  canLoad(_route: Route): boolean {
    if (!this._authService.isLoggedIn()) {
      return true;
    }

    if (this.allowDuplicateAccountFlow()) {
      return true;
    }

    this._authService.checkRole();
    return false;
  }

  private allowDuplicateAccountFlow(route?: ActivatedRouteSnapshot): boolean {
    const flowFromRoute = route?.queryParamMap?.get('flow');
    const flowFromUrl = this._router.parseUrl(this._router.url).queryParams['flow'];
    if (
      flowFromRoute === 'iam_scenario_2' ||
      flowFromUrl === 'iam_scenario_2' ||
      flowFromRoute === 'iam_scenario_4' ||
      flowFromUrl === 'iam_scenario_4'
    ) {
      return true;
    }

    return this._ninFlowService.isRetireAfterIamFlow();
  }
}
